import React from "react";
import styled from "styled-components";
import ClipLoader from "react-spinners/ClipLoader";

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  width: ${props => props.width? props.width:'max-content'};
  padding: 6px 8px;
  cursor:pointer;
  margin:${props => props.margin? props.margin:'auto'};
  ${
    (props)=>{
      if(props.disabled){
        return `
        color: #D8D8D8 !important;
        cursor:default !important;
        background-color: transparent !important;
        border: 1px #D8D8D8 solid;
        border-radius: 3px;
        &:hover{
          background-color: #fff;
        } 
      `;
      }
      if(props.flat){
        return `
          color: #fff;
          background-color: #0288d1;
          border: none;
          border-radius: 3px;
          &:hover{
            background-color: #0372af;
          } 
        `;
      }
      else{
        return `
          color: #0288d1;
          background-color: #fff;
          border: ${props.border? '1px solid #0288d1':'none'};
          border-radius: 3px;
          &:hover{
            background-color: #d0eafa;
          } 
        `;
      }
    }
    
  }
 
`;
const Button = (props) =>{
  return (
    <StyledButton 
      onClick = {props.onClick} 
      width={props.width}
      border={props.border}
      flat={props.flat}
      margin={props.margin}
      disabled={props.disabled}
      style={props.style}
    >
      {
        props.loading?
        (<ClipLoader color={props.flat?"white":"#0288d1"} speedMultiplier={1}  size={15}/>)
        :
        (props.children)
      }
    </StyledButton >
  );
};

export default Button;